import * as React from 'react';
import { NavLink } from 'react-router-dom';
import Nav from '../../modules/Nav/Nav';
import CountryService from '../../services/CountryService';
import CartService from '../../services/CartService';

interface ICartNavProps {
  step: number;
}

class CartNav extends React.Component<ICartNavProps> {

  public render() {
    const countryCode = CountryService.GetInstance().countryCode;

    if (CartService.GetInstance().isEmpty()) {
      // return null; // v SSR return null zlobil, zakomentování by mělo pomoct
    }

    const steps = {
      // Country code urls are not used anymore
      // 1: { title: 'Shopping cart', url: `/${countryCode}/cart`, allow: [] },
      // 2: { title: 'Personal details', url: `/${countryCode}/personal-data`, allow: [ '1' ] },
      // 3: { title: 'Payment and shipping', url: `/${countryCode}/payment-and-shipping`, allow: [ '1', '2' ] },
      // 4: { title: 'Confirmation', url: `/${countryCode}/cart`, allow: [] },
      1: { title: 'Shopping cart', url: '/cart', allow: [] },
      2: { title: 'Personal details', url: '/personal-data', allow: [ '1' ] },
      3: { title: 'Payment and shipping', url: '/payment-and-shipping', allow: [ '1', '2' ] },
      4: { title: 'Confirmation', url: '/cart', allow: [] },
    };

    const currentStep = steps[this.props.step];
    
    return (
      <React.Fragment>
        <Nav type="cart row">
          {Object.keys(steps).map((key: string) => {
            const step = steps[key];
            const isAllowLink = currentStep.allow.indexOf(key) > -1;

            return (
              <div key={key} className={`nav__item col-3${key === this.props.step.toString() ? ' active' : ''}`}>
                {isAllowLink &&
                  <NavLink to={step.url} className="nav__link">
                    <span className="visible-md">{key}. {step.title}</span>
                    <span className="hidden-md">{key}.</span>
                  </NavLink>}
                {!isAllowLink &&
                  <span className="nav__link">
                    <span className="visible-md">{key}. {step.title}</span>
                    <span className="hidden-md">{key}.</span>
                  </span>}
              </div>
            );
          })}
        </Nav>
      </React.Fragment>
    );
  }
}

export default CartNav;


// WEBPACK FOOTER //
// ./src/components/CartNav/CartNav.tsx